module.exports = __webpack_public_path__ + "img/line-chart.2cfd9f25.svg";